import lazy from "./modules/lazy";

export function setupDirective(app) {
  app.use({
    install(Vue) {
      Vue.directive("lazy", lazy);
    },
  });
}
